
const contents = "query FeatureAccessInsightsClients($onBehalfOfUserId: ID) {\n  viewer {\n    canViewActivity(onBehalfOfUserId: $onBehalfOfUserId)\n    canViewLeadershipActivity(onBehalfOfUserId: $onBehalfOfUserId)\n  }\n}\n";
const sha256Hash = "100cb48516f877a16e056a590ce164303c71926283ed92c8971bd7c658a7d956";
export default { contents: contents, sha256Hash: sha256Hash };
